import type SignalNameWithCountry from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalNameWithCountry";
import type { Translatable } from "app/pages/sales-intelligence/types";

export const isSignalNameWithCountry = (name: Readonly<Translatable>): name is SignalNameWithCountry => {
    const { replacements } = name;

    if (typeof replacements === "undefined") {return false;}

    return "countryCode" in replacements || "countries" in replacements;
};
